import { defineStore } from 'pinia'
import User from '@/types/User'
import { ref, watch } from 'vue'
import { useAuthStore } from './auth'

export const useUserStore = defineStore('user', () => {
    const user = ref<User | null>(null);
    const loading = ref(false);
    const errorMessage = ref('');
    const apiUrl = process.env.VUE_APP_DJANGO_BACKEND;
    const authStore = useAuthStore();
  
    const fetchUser = async (forceRefetch=false): Promise<User | null> => {
      if (user.value && !forceRefetch) {
        return user.value
        
      }

      if (loading.value) {
        return new Promise((resolve) => {
          const unwatch = watch(loading, (loadingState) => {
            if (!loadingState) {
              unwatch()
              resolve(user.value)
            }
          })
        })
      }

      try {
        loading.value = true;
        const response = await fetch(`${apiUrl}/api/users/${authStore.session?.user.id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authStore.session?.access_token}`,
          },
        });  
        if (!response.ok) throw new Error('Failed to fetch user');
        const userData: User = await response.json();
        user.value = userData;
        return userData;
      } catch (err) {
        console.error('Error fetching user:', err);
        return null;
      } finally {
        loading.value = false;
      }
    }

    const clearUser = () => {
        user.value = null
      }

      const refreshUser = () => fetchUser(true)

    return { user, loading, errorMessage, fetchUser, clearUser, refreshUser };
  });
